export default __webpack_public_path__ + "static/media/PointStart.4a7cad2d.svg";